import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { AccountStatusService } from './core/services/account-status.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Subject, takeUntil } from 'rxjs';
import { NetworkService } from './core/services/network.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, CommonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  isOnline = navigator.onLine;
  private destroy$ = new Subject<void>();
  title = 'Frontend-Partner-Web';
  constructor(private accountStatus: AccountStatusService,private router:Router,
    private networkService:NetworkService,private toastr:ToastrService) {
    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener('message', (event) => {
        if (event.data?.type === "ACCOUNT_WARNING") {
          console.log("ACCOUNT_WARNING received from SW");
          this.accountStatus.setWarning(true);
          this.accountStatus.setSuspended(false)
        }
      });
    }
    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener('message', (event) => {
        if (event.data?.type === "ACCOUNT_SUSPENDED") {
          console.log("ACCOUNT_WARNING received from SW");
          this.accountStatus.setWarning(false);
          this.accountStatus.setSuspended(true)
        }
      });
    }
    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener('message', (event) => {
        if (event.data?.type === "ACCOUNT_ACTIVE") {
          console.log("ACCOUNT_WARNING received from SW");
          this.accountStatus.setWarning(false);
          this.accountStatus.setSuspended(false)
        }
      });
    }
  }

    ngOnInit(): void {
    this.networkService.isOnline$
      .pipe(takeUntil(this.destroy$))
      .subscribe(status => {
        this.isOnline = status;
      });

      console.log('new build')
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

    refresh(): void {
    if (this.isOnline) {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate([this.router.url]);
      });
    } else {
      this.toastr.error('No internet connection. Please check your network.');
    }
  }


}
